<h1 class="imv-wrapper__title imv-wrapper__title--main">
	@if (easyRead) {
		{{ 'easy-read.imv-title' | translate }}
	} @else {
		{{ 'imv-title' | translate }}
	}
</h1>
<div class="imv-panel__info">
	@if (easyRead) {
		<div class="with-note">
			<p class="imv-wrapper__text--easy-read">
				{{ 'easy-read.imv-text-1' | translate }}
			</p>
			<div class="imgLf">
				<figure>
					<figcaption>{{ 'easy-read.easy-read-btn' | translate }}</figcaption>
				</figure>
			</div>
		</div>
		<p class="imv-wrapper__text--easy-read">
			{{ 'easy-read.imv-text-2' | translate }}
		</p>
	} @else {
		<p class="imv-wrapper__text">
			{{ 'imv-text-1' | translate }}
		</p>
		<p class="imv-wrapper__text">
			{{ 'imv-text-2' | translate }}
		</p>
	}
</div>
<h2 class="imv-wrapper__title">
	@if (easyRead) {
		{{ 'easy-read.procedure-title' | translate }}
	} @else {
		{{ 'procedure-title' | translate }}
	}
</h2>
<div class="imv-panel__info">
	@if (easyRead) {
		<div class="with-note">
			<p class="imv-wrapper__text--easy-read" [innerHTML]="'easy-read.procedure-text-1' | translate"></p>
		</div>
		<div class="with-note">
			<p class="imv-wrapper__text--easy-read" [innerHTML]="'easy-read.procedure-text-2' | translate"></p>
			<button class="imv-wrapper__button__link" eid="init-easy-read" (click)="navigateQuestionnaire()">
					<p [innerHTML]="'easy-read.procedure-text-2-note-1' | translate"></p>
					<p [innerHTML]="'easy-read.procedure-text-2-note-2' | translate"></p>					
			</button>
		</div>
		<p class="imv-wrapper__text--easy-read" [innerHTML]="'easy-read.procedure-text-3' | translate"></p>
	} @else {
		<p class="imv-wrapper__text" [ngClass]="{ 'imv-wrapper__text--easy-read': easyRead }">{{ 'procedure-text' | translate }}</p>
	}
</div>
<section class="imv-wrapper__frequentQuestion" id="frequentQuestion" tabindex="-1" itemscope itemtype="https://schema.org/FAQPage">
	<h2 class="imv-wrapper__title">{{ 'questions-title' | translate }}</h2>
	<article>
		<imv-ui-panel id="faq-1" eid="faq-1" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" [ariaRoleDescription]="'slider'" [ariaLabel]="'panel1-title' | translate" [imvSetAccessibility]="[{
						selector: '.ui-header',
						context: 'light',
						attributes: {
							'aria-controls' : '',
						}
					}]">
			<p slot="title" itemprop="name" [ngClass]="{ 'imv-panel__title': easyRead }">
				@if (easyRead) {
					{{ 'easy-read.panel1-title' | translate }}
				} @else {
					{{ 'panel1-title' | translate }}
				}
			</p>
			<div
				slot="bodyContent"
				class="imv-wrapper__panel-content"
				[ngClass]="{ 'imv-wrapper__panel-content--easy-read': easyRead }"
				itemscope
				itemprop="acceptedAnswer"
				itemtype="https://schema.org/Answer"
			>
				<div itemprop="text">
					@if (easyRead) {
						<p class="imv-panel__text">
							{{ 'easy-read.panel1-text-1' | translate }}
						</p>
						<ul class="imv-panel__cuestions">
							<li>
								{{ 'easy-read.panel1-li-1' | translate }}
							</li>
							<div class="with-note">
								<li [innerHTML]="'easy-read.panel1-li-2' | translate"></li>
								<div class="note">
									<p [innerHTML]="'easy-read.panel1-li-2-note' | translate"></p>
								</div>
							</div>
							<li>{{ 'easy-read.panel1-li-3' | translate }}</li>
							<div class="with-note">
								<li [innerHTML]="'easy-read.panel1-li-4' | translate"></li>
								<div class="note">
									<p [innerHTML]="'easy-read.panel1-li-4-note' | translate"></p>
								</div>
							</div>
						</ul>
						<p>
							{{ 'easy-read.panel1-text-2' | translate }}
						</p>
						<p>
							{{ 'easy-read.panel1-text-3' | translate }}
						</p>
					} @else {
						<p>{{ 'panel1-text-1' | translate }}</p>
						<ul>
							<li>
								<p>{{ 'panel1-li-1' | translate }}</p>
							</li>
							<li>
								<p>{{ 'panel1-li-2' | translate }}</p>
							</li>
							<li>
								<p>{{ 'panel1-li-3' | translate }}</p>
							</li>
						</ul>
						<p>{{ 'panel1-text-2' | translate }}</p>
					}
				</div>
			</div>
		</imv-ui-panel>
	</article>
	<article>
		<imv-ui-panel
			class="imv-panel"
			 id="faq-2" eid="faq-2"
			itemscope
			itemprop="mainEntity"
			itemtype="https://schema.org/Question"
			[ariaRoleDescription]="'slider'"
			[ariaLabel]="'panel2-title' | translate"
			aria-hidden="false"
			[imvSetAccessibility]="[{
						selector: '.ui-header',
						context: 'light',
						attributes: {
							'aria-controls' : '',
						}
					}]"
		>
			<p slot="title" itemprop="name" [ngClass]="{ 'imv-panel__title': easyRead }">
				@if (easyRead) {
					{{ 'easy-read.panel2-title' | translate }}
				} @else {
					{{ 'panel2-title' | translate }}
				}
			</p>
			<div
				slot="bodyContent"
				class="imv-wrapper__panel-content"
				[ngClass]="{ 'imv-wrapper__panel-content--easy-read': easyRead }"
				itemscope
				itemprop="acceptedAnswer"
				itemtype="https://schema.org/Answer"
			>
				<div itemprop="text">
					@if (easyRead) {
						<p>
							{{ 'easy-read.panel2-text-1' | translate }}
						</p>
						<p>
							{{ 'easy-read.panel2-text-2' | translate }}
						</p>
						<ul class="imv-panel__cuestions">
							<li>{{ 'easy-read.panel2-li-1' | translate }}</li>
							<div class="with-note">
								<li [innerHTML]="'easy-read.panel2-li-2' | translate"></li>
								<div class="note">
									<p [innerHTML]="'easy-read.panel2-li-2-note' | translate"></p>
								</div>
							</div>
							<li>{{ 'easy-read.panel2-li-3' | translate }}</li>
							<li>{{ 'easy-read.panel2-li-4' | translate }}</li>
							<li>{{ 'easy-read.panel2-li-5' | translate }}</li>
							<li>{{ 'easy-read.panel2-li-6' | translate }}</li>
							<li>{{ 'easy-read.panel2-li-7' | translate }}</li>
						</ul>

						<p>
							{{ 'easy-read.panel2-text-3' | translate }}
						</p>
						<ul class="imv-panel__cuestions">
							<li>
								{{ 'easy-read.panel2-li-8' | translate }}
							</li>
							<li>
								{{ 'easy-read.panel2-li-9' | translate }}
							</li>
							<div class="with-note">
								<li [innerHTML]="'easy-read.panel2-li-10' | translate"></li>
								<div class="note">
									<p [innerHTML]="'easy-read.panel2-li-10-note' | translate"></p>
								</div>
							</div>
							<div class="with-note">
								<li [innerHTML]="'easy-read.panel2-li-11' | translate"></li>
								<div class="note">
									<p [innerHTML]="'easy-read.panel2-li-11-note' | translate"></p>
								</div>
							</div>
						</ul>
					} @else {
						<p>{{ 'panel2-text-1' | translate }}</p>
						<p>{{ 'panel2-text-2' | translate }}</p>
						<ul>
							<li>
								<p>{{ 'panel2-li-1' | translate }}</p>
							</li>
							<li>
								<p>{{ 'panel2-li-2' | translate }}</p>
							</li>
							<li>
								<p>{{ 'panel2-li-3' | translate }}</p>
							</li>
						</ul>
						<p>{{ 'panel2-text-3' | translate }}</p>
					}
				</div>
			</div>
		</imv-ui-panel>
	</article>
	<article>
		<imv-ui-panel
			class="imv-panel"
			eid="faq-3" id="faq-3"
			aria-hidden="false"
			itemscope
			itemprop="mainEntity"
			itemtype="https://schema.org/Question"
			[ariaRoleDescription]="'slider'"
			[ariaLabel]="'panel3-title' | translate"
			[imvSetAccessibility]="[{
						selector: '.ui-header',
						context: 'light',
						attributes: {
							'aria-controls' : '',
						}
					}]"
		>
			<p slot="title" itemprop="name" [ngClass]="{ 'imv-panel__title': easyRead }">
				@if (easyRead) {
					{{ 'easy-read.panel3-title' | translate }}
				} @else {
					{{ 'panel3-title' | translate }}
				}
			</p>
			<div
				slot="bodyContent"
				class="imv-wrapper__panel-content"
				[ngClass]="{ 'imv-wrapper__panel-content--easy-read': easyRead }"
				itemscope
				itemprop="acceptedAnswer"
				itemtype="https://schema.org/Answer"
			>
				<div itemprop="text">
					@if (easyRead) {
						<p>
							{{ 'easy-read.panel3-text-1' | translate }}
						</p>
						<ul class="imv-panel__cuestions">
							<li>{{ 'easy-read.panel3-li-1' | translate }}</li>
							<li>{{ 'easy-read.panel3-li-2' | translate }}</li>
							<div class="with-note">
								<li [innerHTML]="'easy-read.panel3-li-3' | translate"></li>
								<div class="note">
									<p [innerHTML]="'easy-read.panel3-li-3-note' | translate"></p>
								</div>
							</div>
							<li>{{ 'easy-read.panel3-li-4' | translate }}</li>
							<div class="with-note">
								<li [innerHTML]="'easy-read.panel3-li-5' | translate"></li>
								<div class="note">
									<p [innerHTML]="'easy-read.panel3-li-5-note' | translate"></p>
								</div>
							</div>
						</ul>
						<p>
							{{ 'easy-read.panel3-text-2' | translate }}
						</p>

						<ul class="imv-panel__cuestions">
							<li>{{ 'easy-read.panel3-li-6' | translate }}</li>
							<li>{{ 'easy-read.panel3-li-7' | translate }}</li>
							<li>{{ 'easy-read.panel3-li-8' | translate }}</li>
						</ul>
					} @else {
						<p>{{ 'panel3-text-1' | translate }}</p>
						<ul>
							<li>
								<p>{{ 'panel3-li-1' | translate }}</p>
							</li>
							<li>
								<p>{{ 'panel3-li-2' | translate }}</p>
							</li>
							<li>
								<p>{{ 'panel3-li-3' | translate }}</p>
							</li>
						</ul>
						<p>{{ 'panel3-text-2' | translate }}</p>
						<ul>
							<li>
								<p>{{ 'panel3-li-4' | translate }}</p>
							</li>
							<li>
								<p>{{ 'panel3-li-5' | translate }}</p>
							</li>
							<li>
								<p>{{ 'panel3-li-6' | translate }}</p>
								<ul>
									<li>
										<p>{{ 'panel3-li-7' | translate }}</p>
									</li>
									<li>
										<p>{{ 'panel3-li-8' | translate }}</p>
									</li>
								</ul>
							</li>
						</ul>
					}
				</div>
			</div>
		</imv-ui-panel>
	</article>
	<article>
		<imv-ui-panel
			class="imv-panel"
			eid="faq-4" id="faq-4"
			aria-hidden="false"
			itemscope
			itemprop="mainEntity"
			itemtype="https://schema.org/Question"
			[ariaRoleDescription]="'slider'"
			[ariaLabel]="'panel4-title' | translate"
			[imvSetAccessibility]="[{
						selector: '.ui-header',
						context: 'light',
						attributes: {
							'aria-controls' : '',
						}
					}]"
		>
			<p slot="title" itemprop="name" [ngClass]="{ 'imv-panel__title': easyRead }">
				@if (easyRead) {
					{{ 'easy-read.panel4-title' | translate }}
				} @else {
					{{ 'panel4-title' | translate }}
				}
			</p>
			<div
				slot="bodyContent"
				class="imv-wrapper__panel-content"
				[ngClass]="{ 'imv-wrapper__panel-content--easy-read': easyRead }"
				itemscope
				itemprop="acceptedAnswer"
				itemtype="https://schema.org/Answer"
			>
				<div itemprop="text">
					@if (easyRead) {
						<p>{{ 'easy-read.panel4-text-1' | translate }}</p>
						<p>{{ 'easy-read.panel4-text-2' | translate }}</p>
						<p>{{ 'easy-read.panel4-text-3' | translate }}</p>
						<div class="with-note">
							<p>{{ 'easy-read.panel4-text-4' | translate }}</p>
							<div class="note">
								<p>
									{{ 'easy-read.panel4-text-4-note' | translate }}
								</p>
							</div>
						</div>
					} @else {
						<p>{{ 'panel4-text-1' | translate }}</p>
						<p>{{ 'panel4-text-2' | translate }}</p>
						<p>{{ 'panel4-text-3' | translate }}</p>
						<p>{{ 'panel4-text-4' | translate }}</p>
					}
				</div>
			</div>
		</imv-ui-panel>
	</article>
	<article>
		<imv-ui-panel
			class="imv-panel"
			eid="faq-5" id="faq-5"
			aria-hidden="false"
			itemscope
			itemprop="mainEntity"
			itemtype="https://schema.org/Question"
			[ariaRoleDescription]="'slider'"
			[ariaLabel]="'panel5-title' | translate"
			[imvSetAccessibility]="[{
						selector: '.ui-header',
						context: 'light',
						attributes: {
							'aria-controls' : '',
						}
					}]"
		>
			<p slot="title" itemprop="name" [ngClass]="{ 'imv-panel__title': easyRead }">
				@if (easyRead) {
					{{ 'easy-read.panel5-title' | translate }}
				} @else {
					{{ 'panel5-title' | translate }}
				}
			</p>
			<div
				slot="bodyContent"
				class="imv-wrapper__panel-content"
				[ngClass]="{ 'imv-wrapper__panel-content--easy-read': easyRead }"
				itemscope
				itemprop="acceptedAnswer"
				itemtype="https://schema.org/Answer"
			>
				<div itemprop="text">
					@if (easyRead) {
						<p>{{ 'easy-read.panel5-text-1' | translate }}</p>
						<p>{{ 'easy-read.panel5-text-2' | translate }}</p>
					} @else {
						<p>{{ 'panel5-text-1' | translate }}</p>
						<p>{{ 'panel5-text-2' | translate }}</p>
					}
				</div>
			</div>
		</imv-ui-panel>
	</article>
	<article>
		<imv-ui-panel
			class="imv-panel"
			eid="faq-6" id="faq-6"
			aria-hidden="false"
			itemscope
			itemprop="mainEntity"
			itemtype="https://schema.org/Question"
			[ariaRoleDescription]="'slider'"
			[ariaLabel]="'panel6-title' | translate"
			[imvSetAccessibility]="[{
						selector: '.ui-header',
						context: 'light',
						attributes: {
							'aria-controls' : '',
						}
					}]"
		>
			<p slot="title" itemprop="name" [ngClass]="{ 'imv-panel__title': easyRead }">
				@if (easyRead) {
					{{ 'easy-read.panel6-title' | translate }}
				} @else {
					{{ 'panel6-title' | translate }}
				}
			</p>
			<div
				slot="bodyContent"
				class="imv-wrapper__panel-content"
				[ngClass]="{ 'imv-wrapper__panel-content--easy-read': easyRead }"
				itemscope
				itemprop="acceptedAnswer"
				itemtype="https://schema.org/Answer"
			>
				<div itemprop="text">
					@if (easyRead) {
						<p>{{ 'easy-read.panel6-text-1' | translate }}</p>
						<p>{{ 'easy-read.panel6-text-2' | translate }}</p>
					} @else {
						<p>{{ 'panel6-text-1' | translate }}</p>
						<p>{{ 'panel6-text-2' | translate }}</p>
						<p>{{ 'panel6-text-3' | translate }}</p>
					}
				</div>
			</div>
		</imv-ui-panel>
	</article>
	<article>
		<imv-ui-panel
			class="imv-panel"
			eid="faq-7" id="faq-7"
			aria-hidden="false"
			itemscope
			itemprop="mainEntity"
			itemtype="https://schema.org/Question"
			[ariaRoleDescription]="'slider'"
			[ariaLabel]="'panel7-title' | translate"
			[imvSetAccessibility]="[{
						selector: '.ui-header',
						context: 'light',
						attributes: {
							'aria-controls' : '',
						}
					}]"
		>
			<p slot="title" itemprop="name" [ngClass]="{ 'imv-panel__title': easyRead }">
				@if (easyRead) {
					{{ 'easy-read.panel7-title' | translate }}
				} @else {
					{{ 'panel7-title' | translate }}
				}
			</p>
			<div
				slot="bodyContent"
				class="imv-wrapper__panel-content"
				[ngClass]="{ 'imv-wrapper__panel-content--easy-read': easyRead }"
				itemscope
				itemprop="acceptedAnswer"
				itemtype="https://schema.org/Answer"
			>
				<div itemprop="text">
					@if (easyRead) {
						<p>{{ 'easy-read.panel7-text-1' | translate }}</p>
						<p>{{ 'easy-read.panel7-text-2' | translate }}</p>
						<p>{{ 'easy-read.panel7-text-3' | translate }}</p>
					} @else {
						<p>{{ 'panel7-text-1' | translate }}</p>
						<p>{{ 'panel7-text-2' | translate }}</p>
						<p>{{ 'panel7-text-3' | translate }}</p>
					}
				</div>
			</div>
		</imv-ui-panel>
	</article>
	<article>
		<imv-ui-panel
			class="imv-panel"
			eid="faq-8" id="faq-8"
			aria-hidden="false"
			itemscope
			itemprop="mainEntity"
			itemtype="https://schema.org/Question"
			[ariaRoleDescription]="'slider'"
			[ariaLabel]="'panel8-title' | translate"
			[imvSetAccessibility]="[{
						selector: '.ui-header',
						context: 'light',
						attributes: {
							'aria-controls' : '',
						}
					}]"
		>
			<p slot="title" itemprop="name" [ngClass]="{ 'imv-panel__title': easyRead }">
				@if (easyRead) {
					{{ 'easy-read.panel8-title' | translate }}
				} @else {
					{{ 'panel8-title' | translate }}
				}
			</p>
			<div
				slot="bodyContent"
				class="imv-wrapper__panel-content"
				[ngClass]="{ 'imv-wrapper__panel-content--easy-read': easyRead }"
				itemscope
				itemprop="acceptedAnswer"
				itemtype="https://schema.org/Answer"
			>
				<div itemprop="text">
					@if (easyRead) {
						<p>{{ 'easy-read.panel8-text-1' | translate }}</p>
						<p>{{ 'easy-read.panel8-text-2' | translate }}</p>
					} @else {
						<p>{{ 'panel8-text-1' | translate }}</p>
						<p>{{ 'panel8-text-2' | translate }}</p>
					}
				</div>
			</div>
		</imv-ui-panel>
	</article>
	<article>
		<imv-ui-panel
			class="imv-panel"
			eid="faq-9" id="faq-9"
			aria-hidden="false"
			itemscope
			itemprop="mainEntity"
			itemtype="https://schema.org/Question"
			[ariaRoleDescription]="'slider'"
			[ariaLabel]="'panel9-title' | translate"
			[imvSetAccessibility]="[{
						selector: '.ui-header',
						context: 'light',
						attributes: {
							'aria-controls' : '',
						}
					}]"
		>
			<p slot="title" itemprop="name" [ngClass]="{ 'imv-panel__title': easyRead }">
				@if (easyRead) {
					{{ 'easy-read.panel9-title' | translate }}
				} @else {
					{{ 'panel9-title' | translate }}
				}
			</p>
			<div
				slot="bodyContent"
				class="imv-wrapper__panel-content"
				[ngClass]="{ 'imv-wrapper__panel-content--easy-read': easyRead }"
				itemscope
				itemprop="acceptedAnswer"
				itemtype="https://schema.org/Answer"
			>
				<div itemprop="text">
					@if (easyRead) {
						<div class="with-note">
							<p>{{ 'easy-read.panel9-text-1' | translate }}</p>
							<div class="note">
								<p [innerHTML]="'easy-read.panel9-text-1-note' | translate"></p>
							</div>
						</div>

						<ul class="imv-panel__cuestions">
							<li [innerHTML]="'easy-read.panel9-li-1' | translate"></li>
							<li [innerHTML]="'easy-read.panel9-li-2' | translate"></li>
							<li [innerHTML]="'easy-read.panel9-li-3' | translate"></li>
							<dd>
								<li>{{ 'easy-read.panel9-li-3-1' | translate }}</li>
								<li>{{ 'easy-read.panel9-li-3-2' | translate }}</li>
								<li>{{ 'easy-read.panel9-li-3-3' | translate }}</li>
								<li>{{ 'easy-read.panel9-li-3-4' | translate }}</li>
								<li>{{ 'easy-read.panel9-li-3-5' | translate }}</li>
							</dd>
						</ul>
					} @else {
						<p>{{ 'panel9-text-1' | translate }}</p>
						<ul>
							<li>
								<p innerHtml="{{ 'panel9-text-2' | translate }}"></p>
							</li>
							<li>
								<p innerHtml="{{ 'panel9-text-3' | translate }}"></p>
							</li>
							<li>
								<p innerHtml="{{ 'panel9-text-4' | translate }}"></p>
								<ul>
									<li>
										<p>{{ 'panel9-li-1' | translate }}</p>
									</li>
									<li>
										<p>{{ 'panel9-li-2' | translate }}</p>
									</li>
									<li>
										<p>{{ 'panel9-li-3' | translate }}</p>
									</li>
									<li>
										<p>{{ 'panel9-li-4' | translate }}</p>
									</li>
									<li>
										<p>{{ 'panel9-li-5' | translate }}</p>
									</li>
									<li>
										<p>{{ 'panel9-li-6' | translate }}</p>
									</li>
								</ul>
							</li>
							<li>
								<p innerHtml="{{ 'panel9-text-5' | translate }}"></p>
							</li>
							<li>
								<p innerHtml="{{ 'panel9-text-6' | translate }}"></p>
							</li>
						</ul>
					}
				</div>
			</div>
		</imv-ui-panel>
	</article>
	<article>
		<imv-ui-panel
			class="imv-panel"
			eid="faq-10" id="faq-10"
			aria-hidden="false"
			itemscope
			itemprop="mainEntity"
			itemtype="https://schema.org/Question"
			[ariaRoleDescription]="'slider'"
			[ariaLabel]="'panel10-title' | translate"
			[imvSetAccessibility]="[{
						selector: '.ui-header',
						context: 'light',
						attributes: {
							'aria-controls' : '',
						}
					}]"
		>
			<p slot="title" itemprop="name" [ngClass]="{ 'imv-panel__title': easyRead }">
				@if (easyRead) {
					{{ 'easy-read.panel10-title' | translate }}
				} @else {
					{{ 'panel10-title' | translate }}
				}
			</p>
			<div
				slot="bodyContent"
				class="imv-wrapper__panel-content"
				[ngClass]="{ 'imv-wrapper__panel-content--easy-read': easyRead }"
				itemscope
				itemprop="acceptedAnswer"
				itemtype="https://schema.org/Answer"
			>
				<div itemprop="text">
					@if (easyRead) {
						<p>{{ 'easy-read.panel10-text-1' | translate }}</p>
					} @else {
						<p>{{ 'panel10-text-1' | translate }}</p>
					}
				</div>
			</div>
		</imv-ui-panel>
	</article>
</section>
